// extracted by mini-css-extract-plugin
export default {"body":"page-decoration-box_body__B73IX","tab":"page-decoration-box_tab__8JzD8","dropdown":"page-decoration-box_dropdown__L7n0F","metaItem":"page-decoration-box_metaItem__+yRvm"};